import {
  UserAgent,
  Registerer,
  Inviter,
  SessionState,
  RegistererState
} from 'sip.js';

class sipjs {
  constructor() {
    this.userAgent = null;
    this.session = null;
    this.timer = null;
    this.defaultProps = {};
    this.registered = false;
    this.registerHandler = null;
    this.uaHandler = null;
    this.onInvite = this.onInvite.bind(this);
    this.destroyPhone = this.destroyPhone.bind(this);
    this.cleanRestart = false;
    this.transportOptions = {
      server: `wss://cpaas-j.streamspace.ai`
    };
    this.dtmfOpt = {
      duration: 160,
      interToneGap: 1200
    };
  }

  destroyPhone() {
    this.cleanRestart = true;
    try {
      
      if (this.uaHandler) {
        this.endCall();
      }
  
      if (this.registerHandler) {
        this.registerHandler
          .unregister()
          .then(() => {
            console.log('UNREGISTERED');
          })
          .catch(err => {
            console.log(err);
          });
      }
      if (this.uaHandler && (typeof this.uaHandler.stop === 'function')) {
        this.uaHandler.stop();
      }
    } catch (error) {
      
    }
    this.uaHandler = null;
  }
  initPhone(config, options ) {
    // option for extra configuration
    options = options || {};
    this.destroyPhone();
    let _this = this;
    setTimeout(() => {
      _this.start(config, options);
    }, 1000); 
  }
  clearDisconntionTimeout() {
    if(this.disconnectTimer) {
      clearTimeout(this.disconnectTimer);
      this.disconnectTimer = null;
    }
  }
  start(config, options){
    var _this = this;
    this.cleanRestart = false;
    this.streamHandler = new MediaStream();
    config.delegate = {
      onInvite: this.onInvite
    };
    this.uaHandler = new UserAgent(config);
    this.registerHandler = new Registerer(this.uaHandler, { expires: 3600 });
    this.uaHandler.transport.onDisconnect = (err) => {
      if(this.cleanRestart === false) {
        this.disconnectTimer = setTimeout(() => {
          _this.clearDisconntionTimeout();
          // _this.registerHandler.register()
          _this.start(config, options);
        }, 10 * 1000);
      }
    }
    this.uaHandler.transport.onConnect = (err) => {
      _this.clearDisconntionTimeout();
    }
    this.uaHandler
      .start()
      .then(() => {
        this.registerHandler
          .register()
          .then(() => {
            // options.register && options.register();
          })
          .catch(err => {
            console.log(err);
          });

        this.registerHandler.stateChange.addListener(state => {
          switch (state) {
            case RegistererState.Initial:
              options.initial && options.initial();
              break;
            case RegistererState.Registered:
              options.registered && options.registered();
              _this.clearDisconntionTimeout();
              break;
            case RegistererState.Terminated:
              options.terminated && options.terminated();
              break;
            case RegistererState.Unregistered:
              options.unregistered && options.unregistered();
              break;
          }
        });
      })
      .catch(err => {
        console.log("Register state error", err);
        // options.unregistered && options.unregistered();
      });
  }

  onInvite(invitation) {
    var _this = this;
    let element = document.getElementById('remoteMedia');
    if (this.session) {
      invitation
        .reject()
        .then(() => {
          console.log(
            `rejected invitation from ${invitation.remoteIdentity._displayName}`
          );
        })
        .catch(err => {
          console.log(err);
        });
      return;
    }
    this.session = invitation;
    console.log(invitation);
    this.session.stateChange.addListener(state => {
      switch (state) {
        case SessionState.Initial:
          break;
        case SessionState.Establishing:
          break;
        case SessionState.Established:
          _this.setupRemoteMedia(_this.session, element);
          break;
        case SessionState.Terminating:
        // fall through
        case SessionState.Terminated:
          _this.session = null;
          _this.cleanupMedia(element);
          break;
        default:
          throw new Error('Unknown session state.');
      }
    });

    if (
      invitation.request.hasHeader('X-callType') &&
      invitation.request.getHeader('X-callType') === 'web'
    ) {

      let callDirection = "";
      let isForceAnswer = "false";
      try {
        callDirection = invitation.request.getHeader('X-callDirection');
        isForceAnswer = invitation.request.getHeader('X-isForceAnswer');
        // inboundCall
      } catch (error) {
        
      }
      if( callDirection != "inboundCall" || isForceAnswer == "true" ) {
        setTimeout(() => {
          if( _this.session ){
            _this.acceptCall(_this.session);
          } 
        }, 400);
      }
    } else {
      console.log(`[SIP.JS][onInvite] [this call is inbound...]`);
    }
  }

  setupRemoteMedia(session, element) {
    var _this = this;
    session.sessionDescriptionHandler.peerConnection
      .getReceivers()
      .forEach(receiver => {
        if (receiver.track) {
          _this.streamHandler.addTrack(receiver.track);
        }
      });
    element.srcObject = this.streamHandler;
    element.volume = 1;
    element.play();
  }

  cleanupMedia(element) {
    element.srcObject = null;
    element.pause();
  }

  acceptCall(session) {
    let constrainsDefault = {
      audio: true,
      video: false
    };

    const options = {
      sessionDescriptionHandlerOptions: {
        constraints: constrainsDefault
      }
    };
    if( session ){
      try {

        if( session.state == SessionState.Initial ){
          session.accept(options);
        }
      } catch (error) {
        
      }
    }
  }

  accept( attempt = 0 ){
    let _this = this;
    if( this.session && this.session.state ){
      try {
        this.acceptCall(this.session);
      } catch (error) {
        
      }
    } else {
      if( attempt < 10 ){
        setTimeout(()=>{
          attempt++;
          _this.accept(attempt);
        },100)
      } else {
        console.log(`[autoAnswer] session not define attempt end`,attempt);
      }
      console.log(`[autoAnswer] session not define`,attempt);
    }
  }
  reject(){
    console.log("Reject Call");
    if (this.uaHandler) {
      this.endCall();
    }
    // this.acceptCall(this.session);
  }
  endCall() {
    let session = this.session;
    try {
      
      switch(session.state) {
        case SessionState.Initial:
        case SessionState.Establishing:
          if (session instanceof Inviter) {
            // An unestablished outgoing session
            session.cancel();
          } else {
            // An unestablished incoming session
            session.reject();
          }
          break;
        case SessionState.Established:
          // An established session
          session.bye();
          break;
        case SessionState.Terminating:
        case SessionState.Terminated:
          // Cannot terminate a session that is already terminated
          break;
      }
    } catch (error) {
      console.log("error",error)
    }
  }
}

const sip = new sipjs();
export default sip;



// WEBPACK FOOTER //
// src/lib/sip.js